export const MOBILE_HEADER_HEIGHT = 50;
export const DESKTOP_HEADER_HEIGHT = 72;
export const activeStripeSubscriptions = ["active", "trialing", "past_due"];
export const TextFormats = {
    BOLD: 'bold',
    ITALIC: 'italic',
    UNDERLINE: 'underline',
    STRIKETHROUGH: 'strikethrough',
    CODE: 'code',
    BLOCKQUOTE: 'blockquote',
    SPOILER: 'spoiler',
    TEXT_LINK: 'text_link',
    CLEAR: 'clear'
}

export const blockedFormatsForChatsList = [TextFormats.BOLD, TextFormats.BLOCKQUOTE, TextFormats.TEXT_LINK, TextFormats.SPOILER];